import React, { Component } from 'react';

import { Form, Select } from 'antd';

const FormItem = Form.Item;

export default class extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            maps: [],
            value: props.value
        };
    }

    componentDidMount() {
        this.props.querySearch().then(datas => {

            const data = datas.map(d => d.value);
            const maps = {};

            datas.forEach(d => {
                maps[d.value] = d.label;
            });

            this.setState({
                data,
                maps
            })
        })
    }

    handleChange(value) {
        const name = this.props.name;
        this.setState({
            value: value
        });

        if(this.props.handleChange) {
            this.props.handleChange({
                [name]: value,
                [name+'Name']: this.state.maps[value]
            });
        }
    }

    range(start, stop) {
        var result = [];
        for (start; start <= stop; start++) {
            result.push(start);
        }

        return result;
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.hasOwnProperty('value')) {
            this.setState({
                value: nextProps.value
            });
        }
    }

    render() {
        const {width, label} = this.props;
        const {value, data, maps} = this.state;
        return (
            <FormItem label={label}>
                <Select
                    placeholder='请选择...'
                    value={value}
                    allowClear={true}
                    style={{width: width || 240}}
                    onChange={(value) => {
                        this.handleChange(value);
                    }}
                >
                    {
                        data.map((value) => (
                            <Option value={value}>{maps[value]}</Option>
                        ))
                    }
                </Select>
            </FormItem>
        );
    }
}